import apiClient from './apiClient';
import type {
    DeviceSensor,
    CreateDeviceSensorDto,
    UpdateDeviceSensorDto,
} from '../types/types';

const deviceSensorsService = {
    getAll: async (): Promise<DeviceSensor[]> => {
        const res = await apiClient.get<DeviceSensor[]>('/device-sensors');
        return res.data;
    },

    getById: async (id: number): Promise<DeviceSensor> => {
        const res = await apiClient.get<DeviceSensor>(`/device-sensors/${id}`);
        return res.data;
    },

    create: async (dto: CreateDeviceSensorDto): Promise<DeviceSensor> => {
        const res = await apiClient.post<DeviceSensor>('/device-sensors', dto);
        return res.data;
    },

    update: async (id: number, dto: UpdateDeviceSensorDto): Promise<DeviceSensor> => {
        const res = await apiClient.patch<DeviceSensor>(`/device-sensors/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/device-sensors/${id}`);
        return res.data;
    },
};

export default deviceSensorsService;
